<template lang="pug">
  div
    ods-dialog.dialog(
      :visible.sync="dialogTextEdit"
      :append-to-body="true"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :title= "title"
      left
      width="490px")
      span
        div
          p.subTitle {{ subTitle }}
        slot
          div.slotUserPass
            div
              span
                i Usuario:
              span.userText {{ codeUser }}
              div
                ods-tooltip(class="item" effect="dark" content="Copy" placement="right")
                  ods-button(@click="copyName(codeUser, 'U')" alt="Copy" title="Copy" icon='ods-icon-copy' size='medium' type="" circle='circle')
              ods-popover(
                placement='right'
                v-clickoutside='hidePopover'
                trigger='manual'
                v-model='activePopoverU'
                popper-class='custom-popover'
                width='30px')
                .card__menu
                  h2 Usuario Copiado
            div
              span
                i Clave Inicial:
              span.passText {{ codeUser }}{{ codePass }}
              ods-tooltip(class="item" effect="dark" content="Copy" placement="right")
                ods-button(@click="copyName(codeUser + codePass, 'P')" alt="Copy" title="Copy" icon='ods-icon-copy' size='medium' type="" circle="circle")
              ods-popover(
                  placement='right'
                  v-clickoutside='hidePopover'
                  trigger='manual'
                  v-model='activePopoverP'
                  popper-class='custom-popover'
                  width='30px')
                  .card__menu
                    h2 Clave Copiada
        div.btn
          ods-button(@click="closeDialog") Entendido
</template>
<script type="text/javascript">

import config from '../../../public/config.json'
import Clickoutside from '@ods/ods/lib/utils/clickoutside.js'

export default {
  name: 'DialogTextEdit',
  data () {
    return {
      semilla: config.semilla,
      activePopoverU: false,
      activePopoverP: false,
      previousText: 'Copyyyyy',
      circle: false
    }
  },

  components: {

  },

  directives: {
    Clickoutside
  },

  mounted () {
  },

  props: [
    'dialogTextEdit',
    'title',
    'typeImg',
    'subTitle',
    'codePass',
    'codeUser'
  ],

  methods: {
    showPopover () {
      this.activePopover = true
    },

    hidePopover () {
      this.activePopoverU = false
      this.activePopoverP = false
    },

    copyName (val, model) {
      try {
        // navigator.clipboard.readText().then(
        //   (clipText) => { document.querySelector('.userText').innerText = clipText })
        // const valor = document.querySelector('.userText').innerText
        var type = 'text/plain'
        var blob = new Blob([val], { type })
        // eslint-disable-next-line no-undef
        var data = [new ClipboardItem({ [type]: blob })]

        model === 'U' ? this.activePopoverU = true : this.activePopoverP = true
        navigator.clipboard.write(data).then(
          function () {
            /* success */
            // document.querySelector('.userText').classList.add('copy')
            // alert('success')
          },
          function () {
          /* failure */
            // alert('Noooooooooooooooo')
          })
      } catch (err) {
        console.error(err.name, err.message)
      }
    },

    closeDialog () {
      this.$emit('dialogClosed', false)
      // this.dialogTextEdit = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .subTitle {
    // color: #6E767D;
    font-size: 13px;
    letter-spacing: 0;
    text-align: left;
  }
  /deep/ .dialog {
    .ods-dialog {
      .ods-dialog__header {
        display: flex;
      }
    }
  }
  .pictogram-pic-map {
    height: 120px;
    width: 72px;
  }
  .ods-dialog__body{
    .btn{
      display: flex;
      justify-content: flex-end;
    }
    .slotUserPass{
      margin: 20px 0 20px 0;
      div > span{
        margin: 0px 10px 0px 0;
        i{
          color: #616161;
        }
      }
      div {
        display: flex;
        align-items: center;
        height: 33px;
      }
      /deep/.ods-popover {
        min-width: 77px;
        .card__menu h2{
          font-style: oblique;
          color: #525252;
        }
      }
    }
  }

</style>
